import { TChatHint } from '../../types/chatHint';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatHintQuestionsActionTypes {
  Hide = 'chat/hintQuestions/hide',
  Show = 'chat/hintQuestions/show',
}

export type TChatHintQuestionsPayload = {
  chatId: string;
};

export type TShowChatHintQuestionsPayload = {
  chatId: string;
  hints: TChatHint[];
};

export type TChatHintQuestionsActions =
  | ITypedReduxAction<EChatHintQuestionsActionTypes.Hide, TChatHintQuestionsPayload>
  | ITypedReduxAction<EChatHintQuestionsActionTypes.Show, TShowChatHintQuestionsPayload>;
